import React from "react";
import Routers from "./routes/Routers";

class ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    console.error("Pre-render Error:", error, errorInfo);
  }
  render() {
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Routers />
    </ErrorBoundary>
  );
}

export default App;
